import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';
import { b as bem } from './p-g1JgJ7wn.js';
import { t as transformTagName } from './p-CkrRd9Ud.js';
import { u as unscopeTagName } from './p-BrBYYH1P.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

const cosmosOptgroupCss = ".cosmos-optgroup{display:flex;flex-direction:column;gap:2px;padding-bottom:var(--cosmos-optgroup-padding-bottom, 8px);padding-top:var(--cosmos-optgroup-padding-top)}.cosmos-optgroup__label{--cosmos-text-color:var(--cosmos-optgroup-color);--cosmos-text-font-family:var(--cosmos-optgroup-font-family);--cosmos-text-font-size:var(--cosmos-optgroup-font-size);--cosmos-text-font-style:var(--cosmos-optgroup-font-style);--cosmos-text-font-weight:var(--cosmos-optgroup-font-weight);--cosmos-text-letter-spacing:var(--cosmos-optgroup-letter-spacing);--cosmos-text-line-height:var(--cosmos-optgroup-line-height);--cosmos-text-text-transform:var(--cosmos-optgroup-text-transform);align-items:center;display:var(--cosmos-optgroup-display, flex);height:36px;padding:0 8px 0 8px}.cosmos-optgroup--disabled .cosmos-optgroup__label{--cosmos-text-color:rgba(0, 15, 30, 0.6)}.cosmos-optgroup--disabled.cosmos-optgroup--appearance-light .cosmos-optgroup__label{--cosmos-text-color:rgba(255, 255, 255, 0.6)}";

const generateClassNames = bem('cosmos-optgroup');
const CosmosOptgroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOptgroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * The appearance of the Option Group. It allows the component to adapt to dark or light environments.
         */
        this.appearance = 'dark';
        this.handleSlotChange = () => {
            this.initOptions();
        };
    }
    initOptions() {
        if (this.disabled) {
            const options = Array.from(this.element.querySelectorAll(transformTagName('cosmos-option')));
            options.forEach((option) => {
                option.disabled = true;
            });
        }
    }
    getUnscopedComponentName() {
        // Make sure we have an unscoped tag name available as a data attribute so we can
        // use it to target slotted elements in a scoped environment
        return unscopeTagName(this.element.tagName.toLowerCase());
    }
    componentWillLoad() {
        this.initOptions();
    }
    render() {
        return (h(Host, { key: '8bde048da9da539de49ab4887dc8bf9bf98dd45d', role: "group", "aria-label": this.label, "data-component-name": this.getUnscopedComponentName() }, h("div", { key: 'a160d846dddb773d53c9013987428f9853413f2d', class: generateClassNames({ disabled: this.disabled, appearance: this.appearance }), part: "base" }, this.label && (h("div", { key: 'e2ccc11e47362f53b777759f4f67aefb0a2a31c1', class: generateClassNames('label') }, h("cosmos-text", { key: '0bb383d9ce8e9663f345cec19762319d3a3e2c35', exportparts: "base: label", size: "x-small", weight: "medium", clamp: 1, appearance: this.appearance, kind: "subtle" }, this.label))), h("slot", { key: '9c072985a2ba719d3f0cea169cafbbd8591f4aa7', onSlotchange: this.handleSlotChange }))));
    }
    get element() { return this; }
    static get style() { return cosmosOptgroupCss; }
}, [1, "cosmos-optgroup", {
        "appearance": [513],
        "disabled": [516],
        "label": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-optgroup", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-optgroup":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOptgroup$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOptgroup = CosmosOptgroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOptgroup, defineCustomElement };
